 
import React from 'react'
import { DateRangeProps, DatePickerDefaultSideColumnProps, GroupOptionsProps } from './';
import { defaultRangeProps } from './helpers/defaultRangeProps';
 
 

interface Props extends DatePickerDefaultSideColumnProps {
  selected?: string;
  handleChange?: (x?: GroupOptionsProps) => void;
  timeZone?: string;
  setDateRange?: (x?: DateRangeProps) => void;
  Components?: {
    ColRight?: React.FC<Record<string, unknown> | undefined> | false;
    ColLeft?: React.FC<Record<string, unknown> | undefined>;
  }
} 

export const DatePickerDefaultSideColumn = ({selected, selectGroups, handleChange, setDateRange, timeZone, Components}: Props): JSX.Element => {
  selectGroups = {...(selectGroups || {}), 'select range': Object.values(defaultRangeProps(timeZone))}
  if (!selectGroups || Object.keys(selectGroups || []).length === 0) return <></>

  const ChildComponent = Components?.ColRight || (() => <></>)
 

  return <>{
    Object?.entries(selectGroups)?.map(([groupLabel, options]) => {
    
    return (
      <div className='side-column-group' key={groupLabel}>
        <h3 className='side-column-group-label'>{groupLabel}</h3>

        <select name={groupLabel} id={groupLabel} className='side-column-group-options' onChange={(e) => {
          // is the value of selected to determine the selected option
          const selectedValue = (e?.target?.value || 0 ) as number
          const {label, startTime, endTime } = options[selectedValue] as { label: string, startTime: number, endTime: number }
 
          if (typeof handleChange === 'function') handleChange?.({label, startTime, endTime})
          
          setDateRange?.({label, startTime, endTime})
        }}>
          <option className='side-column-option'> </option>
          {options?.map((option, index) => {
            const isSelected = (option?.label || '') === selected
 
            return (
              <option 
                key={index} 
                className='side-column-option' 
                value={index}
                selected={isSelected} 
              >
                {option?.label || ''}
              </option>
            )
          })}
        </select>
      </div>
    )
  })
  }
  <ChildComponent />
  </>
}
